import React from 'react';
import {Totals} from '../../../../../common/components/Totals/Totals';
import {TotalsSectionDataHooks} from '../TotalsSection';
import {useLocaleKeys} from '../../../../../locale-keys/LocaleKeys';
import {useControllerProps} from '../../../Widget/ControllerContext';

export const SubtotalRow = () => {
  const localeKeys = useLocaleKeys();
  const {cart} = useControllerProps().checkoutStore;

  return (
    <Totals.TotalsRow
      dataHook={TotalsSectionDataHooks.SubtotalRow}
      title={localeKeys.checkout.order_summary.totals.subtotal()}
      value={cart.subtotal.formattedAmount}
    />
  );
};
